<template>
    <div class="button_group">
        <!--<el-button class="btn btn_item">全部</el-button>-->
        <!--<el-button class="btn btn_item">2018</el-button>-->
        <!--<el-button class="btn btn_item" >2019</el-button>-->
        <!--<el-button class="btn btn_item" >2020</el-button>-->
        <!--<el-button class="btn btn_item" >2021</el-button>-->
        <!--<el-button class="btn btn_item" >2022</el-button>-->
        <img src="../../../assets/images/img25.png" alt="" style="width: 900px;height: 52px;">
    </div>
</template>

<script>


export default {
    name: 'MonitorButtonGroup',
    data() {
        return {}
    },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorButtonGroup.vue